import { getEnumValues } from "@utils/enum-utils";

export interface ProfessionalIdentifier {
	name: string;
	countryCode: string;
	regex: string;
	maxLength: number;
	label: string;
	helpText: string;
	description: string;
	placeholder: string;
}

export type ProfessionalIdentifierMap = Map<string, Omit<ProfessionalIdentifier, "name">>;

export interface PostalCodeTemplate {
	validationRegex: string;
	placeholder: string;
	countryCode: string;
}

export enum MedicalProfession {
	IndependentPT = "INDEPENDENT_PT",
	EmployedPT = "EMPLOYED_PT",
	OccupationalPT = "OCCUPATIONAL_PT",
	PmrPhysician = "PMR_PHYSICIAN",
	PsychomotorTherapist = "PSYCHOMOTOR_THERAPIST",
	Eapa = "EAPA",
	Neurologist = "NEUROLOGIST",
	Other = "OTHER",
	None = "NONE",
}

export const medicalProfessions = getEnumValues(MedicalProfession);

export interface VerificationConfig {
	onfidoIdentityEnabled: boolean;
	professionalLicenseEnabled: boolean;
}

export interface CountryUserConfig {
	ptProfessionalIds: ProfessionalIdentifierMap;
	postalCode: PostalCodeTemplate;
	medicalProfessions: MedicalProfession[];
	ptMedicalProfessions: MedicalProfession[];
}
